import p from 'prop-types'

const fastArrayCheck = (typeDef) => function (props, propName, componentName) {
  if (!props) return
  const arr = props[propName]

  if (!arr) return null
  if (!Array.isArray(arr)) {
    return new Error(
      'Invalid prop `' + propName + '` supplied to' +
      ' `' + componentName + '`. Validation failed.'
    )
  }
  if (arr.length === 0) return null

  const midPoint = Math.floor(arr.length / 2)
  p.checkPropTypes(typeDef, arr[0], propName, componentName)
  p.checkPropTypes(typeDef, arr[midPoint], propName, componentName)
  p.checkPropTypes(typeDef, arr[arr.length - 1], propName, componentName)
}

const rawPointType = {
  x: p.number.isRequired,
  y: p.number.isRequired,
  d: p.number.isRequired,
  e: p.number.isRequired
}

export const rawPoints = fastArrayCheck(rawPointType)

const trackPointType = {
  distance: p.number.isRequired
}

export const trackPoints = fastArrayCheck(trackPointType)
